import ModalVideo from "modal-video"

new ModalVideo('.js-modal-btn',{
    youtube:{
        autoplay: 1,
        controls: 1,
        mute: 1,
        loop: 1,
        showinfo: 0
    },
    nocookie: true
});